module.exports = __webpack_public_path__ + "static/media/Zeus.146b246d.jpg";